import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
function TableComponent({ title, data, header, itemsPerPage, showPath = "investisseurs", showSuffix = "", showBaseUrl = null, onShowClick }) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const resolvedShowBaseUrl = showBaseUrl ?? backUrl;
  const isExternalUrl = resolvedShowBaseUrl.startsWith("http");
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);

  const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

  return (
    <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
      <table className="table">
        <thead>
          <tr>
            {title?.can_edit == false &&
            title?.can_show == false &&
            title?.can_destroy == false ? (
              <th></th>
            ) : (
              <th style={{ cursor: "default" }} key="Action" className="text">
                Action
              </th>
            )}
            {header.map((column, index) => (
              <th key={index} style={{ whiteSpace: "nowrap" }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            <>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <ul className="list-unstyled hstack gap-1 mb-0">
                      {title?.can_show ? (
                        <li
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                        >
                          {isExternalUrl ? (
                            <a
                              className="btn btn-sm btn-soft-primary"
                              id={`viewtooltip-${rowIndex}`}
                              href={`${resolvedShowBaseUrl}/${showPath}/${row.id}${showSuffix}`}
                              onClick={onShowClick ? () => onShowClick() : undefined}
                            >
                              <i className="mdi mdi-eye-outline"></i>
                            </a>
                          ) : (
                            <Link
                              className="btn btn-sm btn-soft-primary"
                              id={`viewtooltip-${rowIndex}`}
                              to={`${resolvedShowBaseUrl}/${showPath}/${row.id}${showSuffix}`}
                              onClick={onShowClick ? () => onShowClick() : undefined}
                            >
                              <i className="mdi mdi-eye-outline"></i>
                            </Link>
                          )}
                        </li>
                      ) : null}
                      {title?.can_edit ? (
                        <li title="Editer">
                          <Link
                            className="btn btn-sm btn-soft-info"
                            id={`edittooltip-${rowIndex}`}
                            to={`${backUrl}/investisseurs/${row.id}/edit`}
                          >
                            <i className="mdi mdi-pencil-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_destroy ? (
                        <li title="Supprimer">
                          <a
                            className="btn btn-sm btn-soft-danger"
                            id={`deletetooltip-${rowIndex}`}
                            href="#"
                          >
                            <i className="mdi mdi-delete-outline"></i>
                          </a>
                        </li>
                      ) : null}
                    </ul>
                  </td>
                  {Object.entries(row).map(
                    ([key, value], cellIndex) =>
                      key !== "id" &&
                      (key == "fichier" && value != null ? (
                        <>
                          <td
                            key={cellIndex}
                            style={{
                              whiteSpace: "nowrap",
                              textAlign: isNumeric(value) ? "right" : "left",
                            }}
                          >
                            <a href={value} className="text-dark" download>
                              <i className="bx bx-download h3 m-0" />
                            </a>
                          </td>
                        </>
                      ) : (
                        <>
                          <td
                            key={cellIndex}
                            style={{
                              whiteSpace: "nowrap",
                              textAlign: isNumeric(value) ? "right" : "left",
                            }}
                          >
                            <div dangerouslySetInnerHTML={{ __html: value }} />
                          </td>
                        </>
                      ))
                  )}
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={header.length} style={{ textAlign: "center" }}>
                Aucune donnée à afficher
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"<<"}
        breakLabel={"..."}
        nextLabel={">>"}
        pageCount={Math.ceil(data.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageChange}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default TableComponent;
